/**
 * CheckboxGroup — Labelled checkbox list with optional "Other" free-text.
 *
 * Props:
 *   items        [{ id, name }]  — list of options
 *   selectedIds  number[]         — currently checked IDs
 *   onToggle     fn(id)           — called when any checkbox changes
 *   hasOther     bool             — show "Other:" text input
 *   otherValue   string
 *   onOtherChange fn(str)
 *   error        string
 */
export default function CheckboxGroup({
  items,
  selectedIds,
  onToggle,
  hasOther = false,
  otherValue = '',
  onOtherChange,
  error,
}) {
  return (
    <div>
      <div className="checkbox-group">
        {items.map((item) => (
          <label key={item.id} className="checkbox-item">
            <input
              type="checkbox"
              checked={selectedIds.includes(item.id)}
              onChange={() => onToggle(item.id)}
            />
            {item.name}
          </label>
        ))}
      </div>

      {hasOther && (
        <div className="checkbox-other">
          <label>Other:</label>
          <input
            type="text"
            className="form-control"
            value={otherValue}
            onChange={(e) => onOtherChange(e.target.value)}
            placeholder="Specify…"
            aria-label="Other option"
          />
        </div>
      )}

      {error && <span className="field-error">{error}</span>}
    </div>
  )
}
